export default "__VITE_ASSET__a794013d__"